import { Text, Title, Header, Button } from 'components';
import { PriceBreakDownSummary } from 'components/PriceBreakDownSummary';
import React from 'react';
import {
    BottomBar,
    CarContainer,
    CartContentContainer,
    MargedHeader,
    ProductSummaryContainer,
} from './Cart.style';
import CartItem from './CartItem';
import EmptyCart from './EmptyCart';
import { useCartVM } from './useCartVm';
import { ReactComponent as Trash } from './trash.svg';

const Cart: React.FunctionComponent = () => {
    const { isEmpty, navigateToHome, order, navigateToPayment, flushCart } = useCartVM();

    if (isEmpty) {
        return <EmptyCart navigate={navigateToHome} />;
    }

    return (
        <CarContainer>
            <MargedHeader>
                <Header.Left onClick={navigateToHome}>
                    <Header.Back />
                </Header.Left>
                <Header.Center>
                    <Title text="cart" type="large" weight="regular" />
                </Header.Center>
                <Header.Right onClick={flushCart}>
                    <Trash />
                </Header.Right>
            </MargedHeader>
            <CartContentContainer>
                <ProductSummaryContainer>
                    {order.products.map((product) => (
                        <CartItem {...product} key={product.id} />
                    ))}
                </ProductSummaryContainer>
                <div>
                    <PriceBreakDownSummary {...order.totalPrice} currency="EUR" />
                </div>
            </CartContentContainer>
            <BottomBar>
                <Button fullWidth onClick={navigateToPayment}>
                    <Text text={'goToPayment'} weight="bold" />
                </Button>
            </BottomBar>
        </CarContainer>
    );
};

export default Cart;
